var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"full-image",attrs:{"before-close":_vm.onClose,"modal":true}},[_c('div',{staticClass:"mask"}),_c('div',{staticClass:"image-box"},[_c('img',{attrs:{"src":_vm.url}})]),_c('div',{staticClass:"close",on:{"click":_vm.onClose}},[_vm._v("x")])])
}
var staticRenderFns = []

export { render, staticRenderFns }